import { Api } from "src/utils/api";
import { ORGANIC_API_BASE_URL } from "./organic.constant";

export interface OrganicMetrics {
  organicVolume: number;
  organicImpressions: number;
  organicClicks: number;
  organicCartAdds: number;
  organicUnitsSold: number;
  organicCvr: number;
  organicCtr: number;
  organicOrders: number;
  organicSales: number;
}

interface Resp {
  volume: number;
  impressions: number;
  clicks: number;
  cart_adds: number;
  unit_sold: number;
  orders: number;
  sales: number;
  cvr: number;
  ctr: number;
}

export class OrganicApi extends Api {
  constructor() {
    super(ORGANIC_API_BASE_URL);
  }

  public getOrganicMetrics = async (
    date_start: string,
    date_end: string,
    asin?: string,
  ): Promise<OrganicMetrics> => {
    const r = await this.get<Resp>("/all", {
      date_start,
      date_end,
      saturation: 0,
      ...(asin ? { asin } : {}),
    });

    return {
      organicVolume: r.volume,
      organicImpressions: r.impressions,
      organicClicks: r.clicks,
      organicCartAdds: r.cart_adds,
      organicUnitsSold: r.unit_sold,
      organicCvr: r.cvr,
      organicCtr: r.ctr,
      organicOrders: r.orders,
      organicSales: r.sales,
    };
  };
}
